import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

function ThemeSelector({ onSelectTheme, course_name, user_id }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [topics, setTopics] = useState(null)
  const [API_ENDPOINT, setApiEndpoint] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const API_ENDPOINT = `/api/theories/topics?course_name=${course_name}&user_id=${user_id}`;

        const response = await fetch(API_ENDPOINT, {
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();

        const rawTopics = data.topics
          .sort((a, b) => a.order - b.order)
          .map((topic) => {
            return {
              title: topic.topic,
              title_front: topic.topic_front,
            };
          });
        setTopics(rawTopics);
      } catch (err) {
        navigate("/login");
        return;
      }
    };

    fetchData();
  }, [API_ENDPOINT]);
  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const handleThemeClick = (theme) => {
    onSelectTheme(theme);
    setIsMenuOpen(false);
  };

  const themes = [
    "Введение",
    "Переменные и типы данных",
    "Операторы и выражения",
    "Условные операторы",
    "Циклы",
  ];

  const filteredThemes = themes.filter((theme) =>
    theme.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="theme-selector">
      {/* Main Button with Dynamic Text */}
      <button className="theme-button" onClick={toggleMenu}>
        {isMenuOpen ? "Закрыть" : "Выбрать тему"}
      </button>

      {/* Menu Displayed Based on isMenuOpen */}
      {isMenuOpen && (
        <div className="menu">
          {/* Removed the menu-header with the "закрыть" button */}

          {/* Search Input */}
          <div className="menu-search">
            <input
              type="text"
              placeholder="Поиск"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>

          {/* List of Themes */}
          <ul className="menu-list">
            {topics? (
              topics.map((theme) => (
                <li key={theme.title}>
                  <button
                    className="theme-item"
                    onClick={() => handleThemeClick(theme.title)}
                  >
                    {theme.title_front}
                  </button>
                </li>
              ))
            ) : (
              <li className="no-themes">Темы не найдены</li>
            )}
          </ul>
        </div>
      )}
    </div>
  );
}

export default ThemeSelector;
